module.exports = __webpack_public_path__ + "static/Facebook-c097f77142580a820fc94d595646cf26.jpg";